import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import axios from "axios";
import config from "../../config/config";
import { checkUserPermission } from "../../common/UserPermission";
import { Noimage } from "../../common/imagePath";
import moment from "moment";
import HistoryIcon from "@mui/icons-material/History";

const CustomerSupplierDetailModel = ({ id, model }) => {
  const [historyData, setHistoryData] = useState([]);
  const [details, setDetails] = useState({});
  const [dataSaleList, setDataSaleList] = useState([]);
  const [dataReceivePaymentList, setDataReceivePaymentList] = useState([]);
  const [dataReceiveList, setDataReceiveList] = useState([]);
  const [dataPayBillList, setDataPayBillList] = useState([]);
  const [dataEmployeeList, setDataEmployeeList] = useState([]);

  const navigate = useNavigate();

  const token = localStorage.getItem("Token");
  const location = localStorage.getItem("Location");
  const LoginId = localStorage.getItem("ID");

  const edithandel = (e) => {
    // navigate(`/manage-Items/${itemsDetailsData?.ItemInfo[0]?.ID}`);
  };

  // console.log(dataReceiveList, "dataReceiveList");
  // console.log(dataPayBillList, "dataReceiveList");
  console.log(dataEmployeeList, "dataEmployeeList");

  const Clone = (id) => {
    localStorage.setItem("Clone", id);
    window.location.reload();
  };

  useEffect(() => {
    if (id > 0) {
      if (model === "customer") {
        // axios
        //   .get(
        //     `${config.salesconfigBaseUrl}/sales/saleslist?filtercolumnsearchtext=&pagenumber=1&pagesize=10&filtertext=&ordercolumn=&currentorder=desc&startdate=&status=0&enddate=&salestypeid=0&customerid=0&LocationID=${location}&isShowEcomOrders=1&SalePaymentStatus=0&loginId=${LoginId}`,
        //     {
        //       headers: {
        //         "Content-Type": "application/json;charset=UTF-8",
        //         Authorization: token,
        //       },
        //     }
        //   )
        //   .then((res) => {
        //     setHistoryData(res.data.ResponseData?.list);

        //     // setLoading(false);
        //   })
        //   .catch((err) => {
        //     // setLoading(false);
        //   });

        axios
          .get(
            `${config.customersBaseUrl}/customers/customertransactionlist?filtercolumnsearchtext=&currentorder=desc&ordercolumn=ID&pagesize=20&pagenumber=1&filtertext=&startdate=&salestypeid=1&customerid=${id}&LocationID=${location}&status=0`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            const ListData = res.data.ResponseData;

            const filterSaleData = ListData?.filter(
              (el) => el?.SaleType === "Sale"
            );
            // console.log(ListData, "ListData")
            // console.log(filterSaleData, "ListData")
            setDataSaleList(filterSaleData);
            // setLoading(false);
          })
          .catch((err) => {
            // setLoading(false);
          });

        axios
          .get(
            `${config.customersBaseUrl}/customers/customertransactionlist?filtercolumnsearchtext=&currentorder=desc&ordercolumn=ID&pagesize=20&pagenumber=1&filtertext=&startdate=&salestypeid=-1&customerid=${id}&LocationID=${location}&status=0`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            const ListData = res.data.ResponseData;

            const filterPaymentData = ListData?.filter(
              (el) => el?.SaleType === "Receive Payment"
            );
            // console.log(ListData, "ListData")
            // console.log(filterSaleData, "ListData")
            setDataReceivePaymentList(filterPaymentData);
            // setLoading(false);
          })
          .catch((err) => {
            // setLoading(false);
          });

        axios
          .get(`${config.customersBaseUrl}/customers/findbyid?id=${id}`, {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          })
          .then((res) => {
            setDetails(res.data.ResponseData?.CustomerDetails[0]);
          })
          .catch((err) => {
            // setLoading(false);
          });
      } else if (model === "supplier") {
        // axios
        //   .get(
        //     `${config.receivingBaseUrl}/receivings/listofalldata?filtercolumnsearchtext=&pagenumber=1&pagesize=10&filtertext=&ordercolumn=&currentorder=desc&startdate=&enddate=&receivingtypeid=0&supplierid=0&status=0&LocationID=${location}&receivePaymentStatus=0&loginId=${LoginId}`,
        //     {
        //       headers: {
        //         "Content-Type": "application/json;charset=UTF-8",
        //         Authorization: token,
        //       },
        //     }
        //   )
        //   .then((res) => {
        //     console.log("listofsuspendrecord", res.data.ResponseData?.list);
        //     setHistoryData(res.data.ResponseData?.list);
        //   })
        //   .catch((err) => {
        //     // setLoading(false);
        //   });

        axios
          .get(
            `${config.receivingBaseUrl}/receivings/transactionlistsupplier?filtercolumnsearchtext=&currentorder=desc&ordercolumn=ID&pagesize=20&pagenumber=1&filtertext=&startdate=&enddate=&receivetypeid=2&supplierid=${id}&LocationID=${location}&status=0`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            console.log(res.data.ResponseData, "data 123");
            const ListData = res.data.ResponseData;

            const filterReceiveData = ListData?.filter(
              (el) => el?.ReceivingType === "Receive"
            );
            // console.log(ListData, "ListData")
            // console.log(filterReceiveData, "ListData")
            setDataReceiveList(filterReceiveData);
          })
          .catch((err) => {
            // setLoading(false);
          });

        axios
          .get(
            `${config.receivingBaseUrl}/receivings/transactionlistsupplier?filtercolumnsearchtext=&currentorder=desc&ordercolumn=ID&pagesize=20&pagenumber=1&filtertext=&startdate=&enddate=&receivetypeid=-1&supplierid=${id}&LocationID=${location}&status=0`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            console.log(res.data.ResponseData, "data 123");
            const ListData = res.data.ResponseData;

            const filterPayBillData = ListData?.filter(
              (el) => el?.ReceivingType === "Bill Payment"
            );
            // console.log(ListData, "ListData")
            // console.log(filterPayBillData, "ListData")
            setDataPayBillList(filterPayBillData);
          })
          .catch((err) => {
            // setLoading(false);
          });

        axios
          .get(`${config.suppliersBaseUrl}/suppliers/findbyid?id=${id}`, {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          })
          .then((res) => {
            const data = res.data.ResponseData?.Items[0];
            console.log(data, "supplierdata215");
            setDetails({
              ...data,
              StateProvince: data?.State,
              InternalNotes: data?.Internalnotes,
              AccountNumber: data?.Accountnumber,
            });
          })
          .catch((err) => {
            // setLoading(false);
          });
      } else {
        axios
          .get(
            `${config.accountingBaseUrl}/chartofaccounts/getexpenselist?startdate=&enddate=&payeetype=2`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            console.log(res.data.ResponseData, "data 123");
            const ListData = res.data.ResponseData;

            const filterReceiveData = ListData?.filter(
              (el) => el?.payee === "employee"
            );
            // console.log(ListData, "ListData")
            // console.log(filterReceiveData, "ListData")
            setDataEmployeeList(filterReceiveData);
          })
          .catch((err) => {
            // setLoading(false);
          });

        axios
          .get(`${config.employeesBaseUrl}/employees/findbyid?id=${id}`, {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          })
          .then((res) => {
            const data = res.data.ResponseData.EmployeeDetails[0];
            console.log(data, "employeeData");
            setDetails({
              ...data,
              StateProvince: data?.State,
              EmployeeRole: data?.EmployeeRoleName,
              PhoneNumber: data?.Phonenumber,
              LastName: data?.Lastname,
              FirstName: data?.Firstname,
            });
          });
      }
    }
  }, [id]);

  return (
    <>
      <div
        className="modal fade top-right-modal"
        id="CustomerSupplierDetailModel"
        tabIndex={-1}
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-xl modal-dialog-centered"
          role="document"
        >
          <div className="modal-content" style={{ minHeight: "500px" }}>
            <div className="modal-header">
              <p className="modal-title p-lg">Recent Transaction Log</p>

              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <div>
                    <ul className="nav nav-tabs d-flex justify-content-between">
                      <div className="d-flex">
                        <li className="nav-item fs-5">
                          <a
                            className="nav-link active"
                            href="#ItemsDetailsTab1"
                            data-bs-toggle="tab"
                          >
                            {model === "customer"
                              ? "Sales"
                              : model === "supplier"
                              ? "Receive"
                              : "Employee Recent"}
                          </a>
                        </li>
                        {model !== "employee" && (
                          <li className="nav-item fs-5">
                            <a
                              className="nav-link"
                              href="#ItemsDetailsTab2"
                              data-bs-toggle="tab"
                            >
                              {model === "customer"
                                ? "Receive Payment"
                                : model === "supplier"
                                ? "PayBill"
                                : "Employee"}
                            </a>
                          </li>
                        )}
                        <li className="nav-item fs-5">
                          <a
                            className="nav-link"
                            href="#ItemsDetailsTab3"
                            data-bs-toggle="tab"
                          >
                            {model === "customer"
                              ? "Customer Details"
                              : model === "supplier"
                              ? "Supplier Details"
                              : "Employee Details"}
                          </a>
                        </li>
                      </div>
                    </ul>
                  </div>
                  <div className="tab-content">
                    <div className="tab-pane show active" id="ItemsDetailsTab1">
                      <div className="row">
                        <div className="col-md-12 p-3">
                          <div className="table-responsive">
                            <table className="table mb-0 table-border ">
                              <thead>
                                <tr>
                                  {/* <th>{model === "customer" ? 'Sale Id' : model === "supplier" ? 'Receiving Id': 'Employee'}</th> */}
                                  <th>Date</th>
                                  {model !== "employee" && (
                                    <>
                                      <th>
                                        {model === "customer"
                                          ? "Invoice No."
                                          : model === "supplier"
                                          ? "Bill No."
                                          : "Employee"}
                                      </th>
                                      <th>Qty</th>
                                    </>
                                  )}
                                  <th>Amount</th>
                                  {/* <th>Clone</th> */}
                                  {model === "customer" && <th>Address</th>}
                                  <th>Receipt</th>
                                  <th>Comment</th>
                                </tr>
                              </thead>
                              <tbody>
                                {(model === "customer"
                                  ? dataSaleList
                                  : model === "supplier"
                                  ? dataReceiveList
                                  : dataEmployeeList
                                )?.map((items, index) => {
                                  return (
                                    <tr key={index}>
                                      {/* <td className="col-md-3">{items?.ID}</td> */}
                                      <td className="col-md-3">
                                        {moment(
                                          model === "employee"
                                            ? items?.ReceivingTime
                                            : items?.LatestDate
                                        )?.format("MM-DD-YYYY hh:mm a")}
                                      </td>
                                      {model !== "employee" && (
                                        <>
                                          <td className="col-md-3">
                                            {model === "customer"
                                              ? items?.InvoiceNo
                                              : model === "supplier"
                                              ? items?.BillNo
                                              : ""}
                                          </td>
                                          <td className="col-md-3">
                                            {items?.Qty}
                                          </td>
                                        </>
                                      )}
                                      <td className="col-md-3">
                                        {parseInt(
                                          model === "employee"
                                            ? items?.Total
                                            : items?.Payment
                                        ).toFixed(2)}
                                      </td>
                                      {/* <td
                                        className="col-md-3"
                                        onClick={() => Clone(items?.ID)}
                                        style={{ cursor: "pointer" }}
                                      >
                                        Clone
                                      </td> */}

                                      {model === "customer" && (
                                        <td className="col-md-3">
                                          {items?.ShipBillAddress}
                                        </td>
                                      )}
                                      <td
                                        className="col-md-3"
                                        // onClick={() =>{
                                        //   if(model === "customer"){
                                        //     navigate(`/sales-receipt/${items?.InvoiceNo}`)
                                        //   }else if(model === "supplier"){
                                        //     navigate(`/receiving-receipt/${items?.ID}`)
                                        //   }else{
                                        //     navigate(`/sales-receipt/${items?.InvoiceNo}`)
                                        //   }}
                                        // }
                                        // style={{ cursor: "pointer" }}
                                      >
                                        <Link
                                          to={
                                            model === "customer"
                                              ? `/sales-receipt/${items?.InvoiceNo}`
                                              : model === "supplier"
                                              ? `/receiving-receipt/${items?.ID}`
                                              : `/receiving-receipt/${items?.ID}`
                                          }
                                          target="_blank"
                                        >
                                          Receipt
                                        </Link>
                                      </td>
                                      <td className="col-md-3">
                                        {model === "employee"
                                          ? items?.Comments
                                          : items?.Memo}
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="tab-pane" id="ItemsDetailsTab2">
                      <div className="row">
                        <div className="col-md-12 p-3">
                          <div className="table-responsive">
                            <table className="table mb-0 table-border ">
                              <thead>
                                <tr>
                                  <th>Tran Id</th>
                                  <th>Date</th>
                                  <th>Method</th>
                                  <th>Amount</th>
                                  <th>Comment</th>
                                </tr>
                              </thead>
                              <tbody>
                                {(model === "customer"
                                  ? dataReceivePaymentList
                                  : model === "supplier"
                                  ? dataPayBillList
                                  : []
                                )?.map((items, index) => {
                                  return (
                                    <tr key={index}>
                                      <td className="col-md-3">{items?.ID}</td>
                                      <td className="col-md-3">
                                        {moment(items?.LatestDate)?.format(
                                          "MM/DD/YYYY hh:mm a"
                                        )}
                                      </td>
                                      <td className="col-md-3">
                                        {items?.PaymentType}
                                      </td>
                                      <td className="col-md-3">
                                        {parseInt(items?.Payment).toFixed(2)}
                                      </td>
                                      <td className="col-md-3">
                                        {items?.Memo}
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="tab-pane" id="ItemsDetailsTab3">
                      <div className="row">
                        <div className="col-md-12 p-3">
                          <div className="table-responsive">
                            <table className=" custom-bordered-table">
                              <tbody>
                                {[
                                  ...(model !== "employee"
                                    ? [
                                        {
                                          label: "Company Name",
                                          value: details?.CompanyName,
                                        },
                                      ]
                                    : [
                                        {
                                          label: "Employee Role",
                                          value: details?.EmployeeRole,
                                        },
                                      ]),

                                  {
                                    label: "Name",
                                    value: `${details?.FirstName} ${details?.LastName}`,
                                  },
                                  { label: "E-Mail", value: details?.Email },
                                  {
                                    label: "Phone Number",
                                    value: details?.PhoneNumber,
                                  },
                                  // {
                                  //   label: "Address",
                                  //   value: `${details?.Address1} ${details?.Address2}, ${details?.City}, ${details?.StateProvince} ${details?.Zip}, ${details?.Country}`,
                                  //   // value: `${details?.Address1} ${details?.Address2} ${details?.City} ${details?.StateProvince} ${details?.Zip} ${details?.Country}`,
                                  // },
                                  {
                                    label: "Address",
                                    value: [
                                      details?.Address1,
                                      details?.Address2,
                                      details?.City,
                                      details?.StateProvince +' '+details?.Zip,
                                      details?.Country,
                                    ].filter(Boolean).join(', '),
                                  },
                                  {
                                    label: "Comments",
                                    value: details?.Comments,
                                  },
                                  ...(model === "customer"
                                    ? [
                                        {
                                          label:
                                            "Message to show when adding customer to sale",
                                          value:
                                            details?.MessageToShowWhenAddingCustomerToSales,
                                        },
                                        {
                                          label: "Role Tier",
                                          value: details?.RoleTierName,
                                        },
                                        {
                                          label: "ROUTE",
                                          value: details?.Route,
                                        },
                                        {
                                          label: "LEVEL",
                                          value: details?.LEVEL,
                                        },
                                        { label: "REP", value: details?.REP },
                                      ]
                                    : []),

                                  ...(model !== "employee"
                                    ? [
                                        {
                                          label: "Internal Notes",
                                          value: details?.InternalNotes,
                                        },
                                        {
                                          label: "Account #",
                                          value: details?.AccountNumber,
                                        },
                                        {
                                          label: "Open Balance",
                                          value: parseInt(
                                            details?.OpenBalance
                                          ).toFixed(2),
                                        },
                                      ]
                                    : []),
                                ].map((row, index) => (
                                  <tr key={index}>
                                    <td>{row.label}</td>
                                    <td>{row.value}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerSupplierDetailModel;
